function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.9999 5.45557C12.5404 5.45557 14.5999 7.51506 14.5999 10.0556C14.5999 12.5961 12.5404 14.6556 9.9999 14.6556C7.45939 14.6556 5.3999 12.5961 5.3999 10.0556C5.3999 7.51506 7.45939 5.45557 9.9999 5.45557ZM9.99985 7.67779C8.68664 7.67779 7.62207 8.74235 7.62207 10.0556C7.62207 11.3688 8.68664 12.4333 9.99985 12.4333C11.3131 12.4333 12.3776 11.3688 12.3776 10.0556C12.3776 8.74235 11.3131 7.67779 9.99985 7.67779Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10ZM2.22222 10C2.22222 5.70445 5.70445 2.22222 10 2.22222C14.2955 2.22222 17.7778 5.70445 17.7778 10C17.7778 14.2955 14.2955 17.7778 10 17.7778C5.70445 17.7778 2.22222 14.2955 2.22222 10Z",
  fill: "currentColor"
});

function SvgIconOrigin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrigin);
export default __webpack_public_path__ + "static/media/icon-origin.e38b22b8.svg";
export { ForwardRef as ReactComponent };